import { Link, NavLink } from "@remix-run/react";
import type { ReactNode } from "react";

type NavigationLinkProps = {
  to: string;
  children: ReactNode;
  activatable?: boolean;
  ariaLabel?: string;
};

const LINK_CLASS_NAME =
  "rounded-md px-3 py-2 hover:bg-slate-100 hover:text-slate-800";

export default function NavigationLink({
  to,
  children,
  activatable = false,
  ariaLabel,
}: NavigationLinkProps) {
  if (activatable) {
    return (
      <NavLink
        aria-label={ariaLabel}
        className="relative flex h-16 flex-col justify-center"
        to={to}
        key={to}
      >
        {({ isActive }) => (
          <>
            <div className={LINK_CLASS_NAME}>{children}</div>
            {isActive ? <ActiveMarker /> : null}
          </>
        )}
      </NavLink>
    );
  }

  return (
    <Link className={LINK_CLASS_NAME} key={to} to={to}>
      {children}
    </Link>
  );
}

function ActiveMarker() {
  return <div className="absolute bottom-0 h-[3px] w-full bg-primary" />;
}
